//converts user type from number to name, or vice versa
//have to user areaOrAppLevel = 'area' to get admin type but has to come from areaPermissions not type
export const getUserType = (type, areaOrAppLevel) => {
  let ROLES = [
    {
      typeNo: 0,
      typeName: 'user'
    },
    {
      typeNo: 1,
      typeName: 'admin'
    },
    {
      typeNo: 2,
      typeName: 'super-admin'
    },
    {
      typeNo: -1,
      typeName: 'suspended-user'
    }
  ];

  let userType = ROLES.find((role) => {
    if (typeof type === 'string' || type instanceof String) {
      return role.typeName == type ? role : null;
    } else {
      return role.typeNo == type ? role : '';
    }
  });
  //app permission level can only be basic or super admin (for all areas)
  //area permission level can't be super admin (need to use app level instead)
  if (areaOrAppLevel === 'area') {
    if (userType?.typeNo > 1 || userType?.typeName === 'super-admin') {
      userType.typeNo = 1;
      userType.typeName = 'admin';
    }
  } else {
    //assumes using app level (currentUser.type)
    if (userType?.typeNo === 1 || userType?.typeName === 'admin') {
      userType.typeNo = 0;
      userType.typeName = 'user';
    }
  }

  const data = typeof type === 'string' || type instanceof String ? userType.typeNo : userType.typeName;
  return data;
};

export const capRoomNamesToFit = (roomTitle) => {
  //allow up to 12 characters per row, up to 3 rows
  if (roomTitle.length > 34) {
    roomTitle = `${roomTitle.slice(0, 25)}...`;
  }
  let words = roomTitle.split(' ');
  //split up words into 12 character chunks, split by a '- '

  let newRoomTitle = '';
  let maxLength = 13;
  words.forEach((word, index) => {
    let rows = Math.ceil(word.length / maxLength);
    let newWord = '';
    if (rows > 1) {
      let offset1 = 0;
      let offset2 = 0;
      let offset3 = 0;
      let wordRemainder = word.length - maxLength * (rows - 1);
      if (wordRemainder < 3) {
        if (rows === 2) {
          offset1 = 3 - wordRemainder;
        }
        if (rows === 3) {
          offset2 = 3 - wordRemainder;
        }
        if (rows === 4) {
          offset3 = 3 - wordRemainder;
        }
      }
      newWord += `${word.slice(0, maxLength - offset1)}- <br> ${word.slice(
        maxLength - offset1,
        `${rows === 2 ? word.length - offset2 : maxLength * 2 - offset2}`
      )}`;
      if (rows > 2) {
        newWord += `- <br> ${word.slice(
          maxLength * 2 - offset2,
          `${rows === 3 ? word.length - offset3 : maxLength * 3 - offset3}`
        )}`;
      }
      if (rows > 3) {
        newWord += `- <br> ${word.slice(maxLength * 3 - offset3, word.length)}`;
      }
    } else {
      newWord = word;
    }
    if (index !== words.length - 1) {
      newRoomTitle += `${newWord} `;
    } else {
      newRoomTitle += `${newWord}`;
    }
  });
  return newRoomTitle;
};
